module.exports = __webpack_public_path__ + "5df13c03025ceb1ac113381fb14e740b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Slideshow/Control/left.png
// module id = ./src/components/Slideshow/Control/left.png
// module chunks = 0